import { Link } from '@mui/material';
import { EventPatientProfile } from '@revenuewell/front-end-bundle';
import moment from 'moment';
import * as React from 'react';
import { useEventBus } from '../../../../../../hooks/use-event-bus';
import { Contact } from '../../../../../../services/api-client/contact-api';

export type IProps = {
  familyMembers: Contact[];
};

export const FamilyMembers: React.FC<IProps> = props => {
  const { publish } = useEventBus();

  const renderAge = (contact: Contact) => {
    return <span>{moment().diff(contact.dateOfBirth, 'years', false)}</span>;
  };

  return (
    <>
      {props.familyMembers.length === 0 && <span>-</span>}
      {props.familyMembers.map((familyMember: Contact) => {
        return (
          <div key={`patient-widget-family-member-${familyMember.id}`}>
            <Link
              onClick={() => {
                publish({
                  messageType: 'patientProfile',
                  data: {
                    patientId: familyMember.id
                  } as EventPatientProfile['data']
                });
              }}
            >
              {`${familyMember.firstName} ${familyMember.lastName}`}
            </Link>
            {', '}
            {familyMember.isResponsibleParty && <span>(RP) </span>}
            {renderAge(familyMember)}
          </div>
        );
      })}
    </>
  );
};
